import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Appkit Angular imports (consistent with F1120 module)
import { AppNgMaterialModule } from '../app-ng-material.module';
import { AppNgAppkitModule } from '../app-ng-appkit.module';
import { SharedComponentsModule } from '../shared/components/shared-components.module';
import { SharedDirectivesModule } from '../shared/_directives/shared-directives.module';

// Component, service and directives
import { F965BComponent } from './components/f965b/f965b.component';
import { F965BService } from './services/f965b.service';
import { OnlyDigitsDirective } from './directives/only-digits.directive';
import { F965BScheduleBEntryComponent } from './components/f965b-schedule-b-entry/f965b-schedule-b-entry.component';
import { F965BScheduleBAuditComponent } from './components/f965b-schedule-b-audit/f965b-schedule-b-audit.component';

@NgModule({
  declarations: [
    F965BComponent,
    OnlyDigitsDirective,
    F965BScheduleBEntryComponent,
    F965BScheduleBAuditComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AppNgMaterialModule,
    AppNgAppkitModule,
    SharedComponentsModule,
    SharedDirectivesModule
  ],
  exports: [
    F965BComponent,
    OnlyDigitsDirective,
    F965BScheduleBEntryComponent,
    F965BScheduleBAuditComponent
  ],
  providers: [
    F965BService
  ]
})
export class F965BModule { }
